import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeftArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 9,
	height: 15,
	viewBox: "0 0 9 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8.04281 12.9535L3.00018 7.99613L7.95747 2.9535L6.94044 0.962036L0.000183105 8.02173L7.05991 14.962L8.04281 12.9535Z",
		fill: "#929292"
	})]
});
const ForwardRef = forwardRef(SvgLeftArrow);
export { ForwardRef as ReactComponent };
